import React from 'react';
export function Footer() {
  return <footer className="py-10 px-4 bg-navy text-center" data-id="element-137" data-mp="32wd2qgad7ltj">
      <p className="text-sm text-white" data-id="element-138" data-mp="3gfsoqi9xf4pm">
        © <span className="text-gold-light" data-id="element-139" data-mp="3ggk6ap6ov1ww">Track &amp; Field Coach Ready</span> 2026 — All
        Rights Reserved.
      </p>
      <p className="text-xs text-white/70 mt-2" data-id="element-140" data-mp="32m1ch24t96q7">
        Digital coaching material for Track &amp; Field coaches. Results depend on how the
        system is applied in training.
      </p>
    </footer>;
}